/**
 * 2020年12月8日 10:09:45
 * author:Ljj
 * 统一处理所有请求
 * 为便于查找，命名都request+功能名
 */

import axios from './tx-axios'
var adPositionId = "10014547"
var packageId = "14531"

function requestUpload(url, params, config) {
  return axios.upload(url, params, config)
}
function requestPost(url, params, config) {
  return axios.post(url, params, config)
}
function requestGet(url, params, config) {
  return axios.get(url, params, config)
}
//不要回调的请求
function requestPostWithOutCallBack(url, params) {
  //请求前，添加通用参数
  requestPost(url, params).then(res => {
    console.log("上报成功");
  }).catch(rej => {

  })
}

export default {
  LOGIN_TYPE_PHONE: 1,
  LOGIN_TYPE_NORMAL: 2,
  LOGIN_TYPE_TOKEN: 3,
  // 激活
  requestStart: (params) => requestPost("/device/start", params),
  // 初始化
  requestInit: (params) => requestPost("/init/init", params),
  // 用户登录
  requestLogin: (params) => requestPost("/user/login", params),
  // 一键生成新的账号密码
  requestFastAccount: (params) => requestPost("/user/fastAccount", params),
  // 手机注册/登录
  requestPhoneLogin: (params) => requestPost("/user/phone", params),
  // 发送验证码
  requestSendCode: (params) => requestPost("/verify/send", params),
  // 注销
  requestLogout: (params) => requestPost("/user/loginOut", params),
  // 短信修改密码
  requestAlterPassword: (params) => requestPost("/user/modify", params),
  // 上报，进入游戏
  requestEnterGame: (params) => requestPostWithOutCallBack("/report/roleEnterGame", params),
  // 上报，创建角色
  requestRoleCreate: (params) => requestPostWithOutCallBack("/report/roleCreate", params),
  // 上报，角色升级
  requestRoleUpgrade: (params) => requestPostWithOutCallBack("/report/roleUpgrade", params),
  // 上报，日志
  requestLog: (params) => requestPostWithOutCallBack("/report/log", params),
  // 实名开关
  requestRealNameSwitch: (params) => requestPost("/util/realNameSwitch", params),
  // 防沉迷检查
  requestAntiIndulgence: params => requestPost("/user/checkAntiIndulgence", params),
  // 实名认证
  requestRealnameInfo: (params) => requestPost("/user/saveRealNameInfo", params),
  // 境外实名认证
  requestForeignRealName: (params) => requestPost("/user/foreignRealName", params),
  // 获取玩家信息
  requestUserInfo: (params) => requestPost("/user/getInfo", params),
  // 下单
  requestCreateOrder: (params) => requestPost("/payment/createOrder", params),
  // 获取红包活动详情
  requestRedEnvelopeDetail: (params) => requestPost("/redEnvelope/activityDetail", params),
  // 领取红包
  requestReceiveRedEnvelope: (params) => requestPost("/redEnvelope/getReward", params),
  // 获取个人红包信息
  requestUserRedEnvelope: (params) => requestPost("/redEnvelope/getRedPacketInfo", params),
  // 红包提现至账户
  requestApplyRedEnvelope: (params) => requestPost("/redEnvelope/applyWithdraw", params),
  // 图片上传
  requestUploadImg: (params) => requestUpload("/util/uploadImg", params),
}



// WEBPACK FOOTER //
// ./src/http/index.js